var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.131 2 2.351 6.764 7.16.146-5.706 4.326 2.073 6.854L12.131 16l-5.878 4.09 2.074-6.854L2.621 8.91l7.16-.146L12.13 2Z",
    fill: "currentColor",
    stroke: "#111213",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
};
export default SvgStarFilled;